import { render } from "./AspectContent.vue?vue&type=template&id=5a1f2239&scoped=true"
import script from "./AspectContent.vue?vue&type=script&lang=js"
export * from "./AspectContent.vue?vue&type=script&lang=js"

import "./AspectContent.vue?vue&type=style&index=0&id=5a1f2239&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1f2239"]])

export default __exports__